<template>
  <router-view @password="showResetPasswordToast()"> </router-view>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
    requiresResetPassword: false
  }),
  computed: {
    ...mapState({ needsResetPassword: state => state.needsResetPassword })
  },
  created() {
    this.requiresResetPassword = localStorage.getItem('requiresRestePassword')
  },
  methods: {
    showResetPasswordToast() {
      console.log('resetpasswod neeed')
    }
  }
}
</script>
<style>
.fc {
  background-color: #fff;
  padding: 1rem;
  border-radius: 0.5rem;
}
.title-layout {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
